{
  "navigationRoutes": {
    "home": "Главная"
  },
  "menu": {
    "dashboard": "Дашборд",
    "users": "Пользователи",
    "promoCodes": "Промокоды"
  },
  "search": {
    "placeholder": "Поиск..."
  }
}
